var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row justify-space-between horizontal-divider"},[_c('div',{staticClass:"client"},[_c('h3',{staticClass:"text-capitalize"},[_vm._v(_vm._s(_vm.indicatorName))]),_c('p',[_vm._v("Track "+_vm._s(_vm.level)+" progress here")])]),(_vm.brandIndicators && _vm.brandIndicators.length)?_c('div'):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }